module.exports = {

    data(){
        return {
            form: new Form({
                type: '',
                name: '',
                email: '',
                phone: '',
                message: '',
            })
        }
    },

    methods:{
        onSubmit(){
            this.form.post(event.target.action).then(response => {
                Alert.success(response.message)
            }).catch(errors => {
                Alert.error(errors.first())
            })
        }
    }
}
